import React, { useEffect, useMemo } from 'react'
import { useSearchParams } from 'react-router-dom'

import { useMasterBillActions } from '../stores/useMasterBillStore'
import { useSearchActions, useSearchState } from '../stores/useSearchStore'
import { MasterBillOption } from '../types/masterBill'

import MasterBillAutocomplete from './MasterBillAutocomplete'

const SearchFilterV2: React.FC = () => {
  const { masterBillId, masterBills } = useSearchState()
  const { restore, fetchMasterBills, changeMasterBillId } = useSearchActions()
  const { fetchMasterBill } = useMasterBillActions()
  const [searchParams, setSearchParams] = useSearchParams()

  // 转换为 MasterBillOption 格式
  const masterBillOptions = useMemo((): MasterBillOption[] => {
    return masterBills.map((bill) => ({
      label: bill.masterBlNumber,
      value: bill.id,
      masterBlNumber: bill.masterBlNumber,
      containerNumber: bill.containerNumber,
      statusDisplay: bill.statusDisplay,
      houseBills: bill.houseBills?.map((hb) => ({
        id: hb.id,
        houseBlNumber: hb.houseBlNumber,
        cargoDetails: hb.cargoDetails?.map((cd) => ({
          id: cd.id,
          cargoNumber: cd.cargoNumber || '',
          packages: cd.packages || 0
        }))
      })),
      rawData: bill
    }))
  }, [masterBills])

  // 找到当前选中的选项
  const selectedOption = useMemo(() => {
    if (!masterBillId) return null
    return masterBillOptions.find((opt) => opt.value === masterBillId) || null
  }, [masterBillId, masterBillOptions])

  // 初始化选中的主提单
  useEffect(() => {
    if (masterBillId) {
      fetchMasterBill(masterBillId)
    }
  }, [masterBillId])

  // 加载主提单列表
  useEffect(() => {
    // 获取主提单列表
    fetchMasterBills()
    // 从URL恢复
    restore(searchParams)
  }, [])

  return (
    <div className="bg-white rounded-lg shadow p-4">
      <h3 className="text-lg font-medium text-gray-900 mb-4">筛选条件</h3>
      <div className="grid grid-cols-1 gap-4">
        <MasterBillAutocomplete
          className='w-full'
          options={masterBillOptions}
          value={selectedOption}
          onChange={(value) => {
            changeMasterBillId(
              value ? Number(value.value) : undefined,
              searchParams,
              setSearchParams
            )
          }}
        />
      </div>
    </div>
  )
}

export default SearchFilterV2
